/**
 * Collapsible Rows Handler for Savia Product Page
 * This script enhances the functionality of collapsible rows to prevent animation issues
 * and ensure content is visible when expanded
 */

document.addEventListener('DOMContentLoaded', function() {
  // Enhanced collapsible rows interaction
  const collapsibleRows = document.querySelectorAll('.savia-collapsible-row');
  
  // First, fix any broken icon markup
  collapsibleRows.forEach(row => {
    const icon = row.querySelector('.savia-collapsible-row__icon');
    if (icon && !icon.querySelector('svg')) {
      // If the icon is broken, insert the proper SVG
      icon.innerHTML = '<svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>';
    }
  });
    // Function to ensure expanded collapsible rows display properly
  function forceCollapsibleRowsDisplay() {
    collapsibleRows.forEach(row => {
      if (row.hasAttribute('open')) {
        const contentWrapper = row.querySelector('.savia-collapsible-row__content-wrapper');
        const content = row.querySelector('.savia-collapsible-row__content');
        
        if (contentWrapper) {
          contentWrapper.style.height = 'auto';
          contentWrapper.style.overflow = 'visible';
          contentWrapper.style.display = 'block';
          contentWrapper.style.opacity = '1';
          contentWrapper.style.visibility = 'visible';
          contentWrapper.style.maxHeight = '2000px'; // Set a large max-height
          contentWrapper.style.position = 'relative';
          contentWrapper.style.zIndex = '5'; // Ensure it displays above product zoom
        }
        
        if (content) {
          content.style.display = 'block';
          content.style.visibility = 'visible';
          content.style.opacity = '1';
          content.style.transform = 'translateY(0)';
          content.style.position = 'relative';
          content.style.zIndex = '5';
          content.style.maxHeight = '2000px';
        }
      }
    });
  }
  
  // Call the function on page load
  forceCollapsibleRowsDisplay();
  
  // Setup the click behavior
  collapsibleRows.forEach(row => {
    const summary = row.querySelector('.savia-collapsible-row__summary');
    const contentWrapper = row.querySelector('.savia-collapsible-row__content-wrapper');
    const content = row.querySelector('.savia-collapsible-row__content');
    
    if (summary && content) {
      summary.addEventListener('click', function(e) {
        // Let the default details/summary behavior happen
        // but ensure proper visibility after a small delay
        setTimeout(() => {
          forceCollapsibleRowsDisplay();
        }, 10);
      });
    }
  });
  
  // Make sure icon with text blocks are visible
  const iconTextContainer = document.querySelector('.icon-text-container');
  if (iconTextContainer) {
    iconTextContainer.style.display = 'flex';
    
    const iconTextItems = iconTextContainer.querySelectorAll('.icon-text-item');
    iconTextItems.forEach(item => {
      item.style.display = 'flex';
    });
  }
    // Add a special event handler for the product zoom and monitor for visibility issues
  document.addEventListener('click', function(e) {
    // If we clicked on a zoom element, ensure our collapsible rows are still visible
    if (e.target.closest('.zoom-img') || e.target.closest('.product-zoom-container')) {
      setTimeout(forceCollapsibleRowsDisplay, 100);
      // Additional check after zoom animation completes
      setTimeout(forceCollapsibleRowsDisplay, 500);
    }
  });
  
  // Ensure display when window resizes or on scroll events
  window.addEventListener('resize', function() {
    setTimeout(forceCollapsibleRowsDisplay, 100);
  });
  
  window.addEventListener('scroll', function() {
    // Debounce scroll events to avoid excessive processing
    if (window.scrollTimeout) {
      clearTimeout(window.scrollTimeout);
    }
    window.scrollTimeout = setTimeout(forceCollapsibleRowsDisplay, 200);
  });
});
